import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import bulkRequestKeys, { TQueryKey } from '@app/features/bulkRequest/queryKey';
import BulkRequest from '@app/features/bulkRequest/types/BulkRequest';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { getBulkRequest } from '@app/store/transport-layer/bulk-request/bulk-requests';

function useBulkRequestItem(
  id: string,
  options?: UseQueryOptions<BulkRequest, AxiosError, BulkRequest, TQueryKey>
) {
  const workspaceId = useWorkspaceId();

  return useQuery<BulkRequest, AxiosError, BulkRequest, TQueryKey>(
    bulkRequestKeys.query.byId(id),
    () => getBulkRequest(workspaceId, id),
    {
      staleTime: 1000,
      enabled: !!workspaceId && !!id,
      ...options,
    }
  );
}

export default useBulkRequestItem;
